import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4decd084")
const _hoisted_1 = { class: "main-grid" }
const _hoisted_2 = { class: "\n        d-md-block\n        sidebar\n        collapse\n        shadow-sm\n        bg-white\n        position-relative\n        overflow-hidden\n        navigation-container\n      " }
const _hoisted_3 = {
  key: 1,
  class: "circles-container"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "circle-back" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "circle-front" }, null, -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "main-content px-4 py-5 main-area-container" }
const _hoisted_8 = {
  key: 1,
  class: "authenticating"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_NavButton = _resolveComponent("NavButton")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ResetYourPassword = _resolveComponent("ResetYourPassword")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.partnerProgram !== _ctx.PartnerPrograms.AKKO)
      ? (_openBlock(), _createBlock(_component_Header, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.partnerProgram === _ctx.PartnerPrograms.AKKO)
      ? (_openBlock(), _createBlock(_component_NavButton, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.hasLoadedPartner)
          ? (_openBlock(), _createBlock(_component_Navigation, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.partnerProgram === _ctx.PartnerPrograms.AKKO)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("main", _hoisted_7, [
        (_ctx.hasLoadedPartner)
          ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
          : _createCommentVNode("", true),
        (!_ctx.isAuthed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.shouldResetPassword)
      ? (_openBlock(), _createBlock(_component_Modal, { key: 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_ResetYourPassword)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}